<template>
    <Layout ref="layout" v-bind:enable_tagsview.sync="enable_tagsview" active="2" :isOnlyShowMainContainer="isOnlyShowMain">
        <div class="cus-header" v-if="transportNodes && transportNodes.length > 0">
            <el-row :style="{ width: (transportNodes.length * 7 >= 100 ? 98 : transportNodes.length * 7) + '% !important' }">
                <el-steps simple style="padding: 0 0 0 30px !important">
                    <el-step v-for="(step, index) in transportNodes" :key="index" icon="none">
                        <div
                            :title="step.modifier != null && step.modifier != undefined ? `转运人：${step.modifier}` : ''"
                            slot="title"
                            class="align-center ellipsis"
                            style="font-size: 14px; color: black; min-width: 100px; margin-left: -40px"
                        >
                            <span
                                style="position: absolute; margin-left: -30px; font-size: 10px; font-weight: bold"
                                v-if="index == 0 || $moment(transportNodes[index - 1].occur_time).format('MM/DD') !== $moment(step.occur_time).format('MM/DD')"
                            >
                                {{ step.occur_time && $moment(step.occur_time).format('MM/DD') }}
                            </span>
                            <span :title="step.modifier != null && step.modifier != undefined ? `转运人：${step.modifier}` : ''">
                                {{ step.occur_time && $moment(step.occur_time).format('HH:mm') }}
                                <br />
                                {{ step.title || '&nbsp;' }}
                            </span>
                        </div>
                    </el-step>
                </el-steps>
            </el-row>
        </div>
        <div style="height: 35px">
            <ScrollPane style="height: 35px">
                <tree-menu :data="_menu" mode="horizontal" :router="false"></tree-menu>
            </ScrollPane>
        </div>
        <el-scrollbar :style="{ height: '100%' }">
            <div style="margin: 10px 10px 5px 5px; background: #ffffff">
                <router-view v-if="isRouterAlive" @changeSurgeInfo="changeSurgeInfo" @refreshsurgeInfos="refreshsurgeInfos"></router-view>
            </div>
        </el-scrollbar>
        <!-- 顶部菜单区域 -->
        <template v-slot:ref_header>
            <el-row style="line-height: 50px">
                <el-col :span="6" class="hidden-lg-and-down">
                    <Breadcrumb></Breadcrumb>
                </el-col>
                <el-col :md="10" :lg="8" :xl="4" :title="`床号${activeSurgery.bed_no || '--'}/${T(`surgery.visit_no`)}${activeSurgery.visit_no}/${T(`his_id`)}${activeSurgery.his_id || '--'}/门诊号${activeSurgery.outpatient_no || '--'}/性别${activeSurgery.sex || '--'}/年龄${(activeSurgery.age || '')}`">
                    <span class="ellipsis"
                        ><b>{{ activeSurgery.patient_name }}</b
                        >&nbsp;{{ activeSurgery.bed_no || '--' }}/{{ activeSurgery.visit_no }}/{{ activeSurgery.his_id || '--' }}/{{ activeSurgery.outpatient_no || '--' }}/{{ activeSurgery.sex || '--' }}/
                        <span :style="{ color: activeSurgery.ageColor }">{{ activeSurgery.age || '--' }}</span>
                    </span>
                </el-col>
                <el-col :span="2" :title="`${activeSurgery.dic_section || '--'}`">
                    <span class="ellipsis">{{ activeSurgery.dic_section || '--' }}</span>
                </el-col>
                <el-col :span="6" class="padding5 padding-none-v" :title="activeSurgery.diseases">
                    <span class="ellipsis"
                        ><b>{{ activeSurgery.diseases }}</b></span
                    >
                </el-col>
                <el-col :span="!activeSurgery.remark?6:3" class="padding5 padding-none-v" :title="activeSurgery.surgeries">
                    <span class="ellipsis"
                        ><b>{{ activeSurgery.surgeries }}</b></span
                    >
                </el-col>
                <el-col :span="3" :title="activeSurgery.remark" class="ellipsis" v-if="activeSurgery.remark">
                    <span class="el-icon-warning fg-danger"></span>
                    <b>{{ activeSurgery.remark || '' }}</b>
                </el-col>
            </el-row>
        </template>

        <!-- 左侧菜单区域 -->
        <div slot="ref_content">
            <div style="padding: 10px 10px 0px 10px; height: 70px">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                <item-input
                    type="scan"
                    class="margin5 margin-none-h"
                    v-model="searchKey2"
                    :placeholder="getPlaceholder1"
                    size="mini"
                    :isShowCamera="isShowCamera"
                    :autofocus="true"
                    @input="loadSurgeries2"
                    style="width: 160px; display: inline-block"
                ></item-input>
                <el-popover popper-class="surgery-index-popover" placement="right-start" width="430" trigger="manual" v-model="popovervisible" @after-leave="onPopoverHide">
                    <div :style="{ 'max-height': `${this.screenHeight - 200}px`, overflow: `auto` }">
                       <h3>患者列表默认展开</h3>
                            <item-input
                                type="radio"
                                v-model="isdefaultcollapse"
                                :options="[
                                    { value: 0, label: '否' },
                                    { value: 1, label: '是' }
                                ]"
                                :borderd="true"
                                @input="collapseSurgeries()"
                            ></item-input>
                        <h3>精确查询：</h3>
                        <item-input type="string" v-model="searchKey" :placeholder="getPlaceholder2" size="mini"></item-input>
                        <div v-for="condition in exactQueryConditions" :index="condition.type" :key="condition.type">
                            <h3>{{ condition.type }}</h3>
                            <item-input type="radio" v-model="condition.selectedItem" :options="condition.childrenItems" :borderd="true"></item-input>
                        </div>
                        <div>
                            <h3>医护</h3>
                            <item-input
                                type="radio"
                                v-model="is_own"
                                :options="[
                                    { value: false, label: '全部患者' },
                                    { value: true, label: '我的患者' }
                                ]"
                                :borderd="true"
                            ></item-input>
                        </div>
                        <div>
                            <h3>麻醉类型</h3>
                            <item-input
                                type="radio"
                                v-model="is_local_anes"
                                :options="[
                                    { value: 0, label: '全部' },
                                    { value: 1, label: '局麻' },
                                    { value: 2, label: '非局麻' }
                                ]"
                                :borderd="true"
                                @input="loadSurgeries(true)"
                            ></item-input>
                        </div>
                        <div>
                            <h3>手术室外麻醉</h3>
                            <item-input type="radio" v-model="enum_outoperatingroomtype" :options="allOutOperatingRoomTpyes"
                                :borderd="true"></item-input>
                        </div>
                        <div>
                            <h3>手术类型</h3>
                            <item-input type="radio" v-model="surgery_type" :options="surgeryTypes" :borderd="true" @input="loadSurgeries(true)"></item-input>
                        </div>
                        <div>
                            <h3>计费</h3>
                            <item-input
                                type="radio"
                                v-model="charge_status"
                                :options="[
                                    { value: 0, label: '全部' },
                                    { value: 1, label: '未计费' },
                                    { value: 2, label: '计费待发送' },
                                    { value: 3, label: '计费已发送' },
                                    { value: 4, label: '计费待审核' },
                                    { value: 5, label: '加急收费' }
                                ]"
                                :borderd="true"
                                @input="loadSurgeries(true)"
                            ></item-input>
                        </div>
                        <div>
                            <h3>状态</h3>
                            <item-input type="checkboxgroup" v-model="surgery_status" :options="surgeryStatus" :borderd="true" @input="loadSurgeries"></item-input>
                        </div>
                        <div>
                            <h3>分组</h3>
                            <item-input
                                type="radio"
                                v-model="group_key"
                                :options="[
                                    { value: 0, label: '手术间' },
                                    { value: 1, label: '病区' }
                                ]"
                                :borderd="true"
                                @input="loadSurgeries(true)"
                            ></item-input>
                        </div>
                        <div>
                            <h3>手术间</h3>
                            <item-input type="radio" v-model="dic_room_id" :options="operationRoom" :borderd="true"></item-input>
                        </div>
                    </div>
                    <el-link id="popoverBtn" slot="reference" class="align-right" style="font-weight: bold; font-size: 20px" @click="isFirst = false">+</el-link>
                </el-popover>
            </div>

                <div v-if="_surgeries.length == 0" class="fg-info">暂无手术</div>
                <el-menu class="cus-menu-v surgery" :default-openeds="defaultOpeneds" mode="vertical">
                    <template>
                        <div
                            v-if="_surgeries.length > 0"
                            class="cus-collapse-item surgery-header"
                            style="text-align: left; padding-left: 10px; background-color: var(--primary-color, rgb(0, 150, 136)); color: #ffffff; height: 32px"
                        >
                            <span style="font-size: 20px;">合计:{{ total }}<span class="cus-button is-circle" style="float: right;" @click="loadSurgeries(true)" title="刷新"><span class="el-icon-refresh"></span></span></span>
                        </div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: this.screenHeight - 200 + 'px' }">
                        <el-submenu v-for="item in _surgeries" :index="item.room_id" :key="item.room_id">
                            <div slot="title" class="cus-collapse-item surgery-header">
                                <span slot="title" style="font-size: 20px;">{{ item.room }}</span>
                                <span class="cus-button is-circle" style="background:#FFFFFF;line-height: 10px;color:var(--primary-color, #009688);display: inline-flex;width: 20px;justify-content: center;height: 20px;}">{{
                                    item.children.length
                                }}</span>
                            </div>
                            <div v-for="v in item.children" :key="v.id">
                                <div class="surgery-content cursor-pointer" :class="{ 'is-active': v.id == activeSurgeryId }" @click="cus_collapse_item_active(v.id)" @contextmenu.prevent="onRightClick(v.id)">
                                    <el-tooltip placement="right-start" effect="light">
                                        <div slot="content" class="align-left">
                                            <div class="margin10 margin-none-h"><label class="fg-info">计划手术时间：</label>{{ $moment(v.plan_time).format('YYYY/MM/DD HH:mm') || '--' }}</div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">实际手术时间：</label>{{ (v.fact_inRoom_time && $moment(v.fact_inRoom_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">复苏时间：</label>{{ (v.in_recovery_room && $moment(v.in_recovery_room).format('YYYY/MM/DD HH:mm')) || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h"><label class="fg-info">科　　室：</label>{{ v.dic_section || '--' }}</div>
                                            <div class="margin10 margin-none-h"><label class="fg-info">床　　号：</label>{{ v.bed_no || '--' }}</div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">{{ T(`surgeryinfo.plan_anes_doctor`) }}：</label>{{ v.anes_doctor || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">{{ T(`surgeryinfo.plan_equipment_nurse`) }}：</label>{{ v.equipment_nurse || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">{{ T(`surgeryinfo.plan_circuit_nurse`) }}：</label>{{ v.circuit_nurse || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h">
                                                <label class="fg-info">{{ T(`surgeryinfo.plan_surgeon`) }}：</label>{{ v.surgeon || '--' }}
                                            </div>
                                            <div class="margin10 margin-none-h"><label class="fg-info">手术状态：</label>{{ v.surgery_status || '--' }}</div>
                                            <div class="margin10 margin-none-h"><label class="fg-info">注意事项：</label>{{ v.remark || '--' }}</div>
                    <el-button  v-if="!v.is_local_anes" type="primary" size="mini" @click="loadDocument(1,v.id)" >查看麻醉单</el-button>

                                        </div>
                                        <div style="position: relative;" :style="{color:v.is_expedited?'red':''}">

                                            <!-- :style="{ width: (transportNodes.length * 7 >= 100 ? 98 : transportNodes.length * 7) + '% !important' } -->

                                            <span
                                                style="margin-left: -15px; width: 14px; position: absolute; margin-top: 2px; line-height: 14px; display: block; border-radius: 50%"
                                                :class="v.enum_surgery_status == 30 ? 'bg-danger' : v.enum_surgery_status == 20 || v.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                                            >
                                                <span style="color: white; font-size: 10px; display: block; text-align: center">{{ `　` }}</span>
                                            </span>
                                            <b>{{ v.patient_name }}&nbsp;{{ v.sex || '--' }}&nbsp;{{ v.ageVal || '--' }}</b>
                                            <span class="circle fg-red borderd" v-if="v.is_reoperation">再</span>
                                            <span class="circle fg-red borderd" v-if="v.is_expedited">费</span>
                                            <span style="font-size: 10px; float: right">{{ v.fact_inRoom_time && $moment(v.fact_inRoom_time).format('HH:mm') || $moment(v.plan_time).format('HH:mm') }}&nbsp;&nbsp;</span>
                                            <div class="ellipsis font-size12" style="margin-left: -10px">
                                                {{ v.surgeries || '--' }}
                                            </div>
                                            <div style="margin-left: -10px">
                                                <b>
                                                    <el-tag
                                                        v-for="surgeryTipItem in v.surgeryTipItemsList"
                                                        :key="surgeryTipItem.label"
                                                        :title="surgeryTipItem.title"
                                                        :style="surgeryTipItem.style"
                                                        size="mini"
                                                        >{{ surgeryTipItem.label }}</el-tag
                                                    >
                                                </b>
                                            </div>
                                        </div>
                                    </el-tooltip>
                                </div>
                            </div>
                        </el-submenu>
                          </el-scrollbar>
                    </template>
                </el-menu>

        </div>
        <el-dialog :title="checkstatus.title" :visible.sync="checkstatus.dialogFormVisible">
            <div style="font-size: 18px; text-align: left; margin-bottom: 20px; line-height: 30px">
                <div>
                    <span
                        >姓名：<b>{{ checkstatus.patient_name }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >床号：<b>{{ checkstatus.bed_no || '--' }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >性别：<b>{{ checkstatus.sex || '--' }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >年龄：<b>{{ checkstatus.age || '--' }}</b></span
                    >
                    <span
                        >费别：<b>{{ checkstatus.pay_type || '--' }}</b></span
                    >&nbsp;&nbsp;
                </div>
                <div>
                    <span
                        >台次：<b>{{ checkstatus.scheduled_sequence || checkstatus.sequence || '--' }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >{{ T(`surgery.visit_no`) }}：<b>{{ checkstatus.visit_no || '--' }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >{{ T(`his_id`) }}：<b>{{ checkstatus.his_id || '--' }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >隔离：<b class="fg-red">{{ checkstatus.isolation_status || '--' }}</b></span
                    >&nbsp;&nbsp;
                </div>
                <div>
                    <span
                        >{{ T(`surgeryinfo.plan_circuit_nurse`) }}：<b>{{ checkstatus.circuit_nurse }}</b></span
                    >&nbsp;&nbsp;
                    <span
                        >{{ T(`surgeryinfo.plan_equipment_nurse`) }}：<b>{{ checkstatus.equipment_nurse }}</b></span
                    >&nbsp;&nbsp;
                </div>
                <div>
                    科室：<b>{{ checkstatus.dic_section || '--' }}</b>
                </div>
                <div>
                    {{ T(`surgeryinfo.plan_surgeon`) }}：<b>{{ checkstatus.surgeon || '--' }}，{{ checkstatus.surgeon_assistants || '--' }}</b>
                </div>
                <!-- <div>手术部位：{{checkstatus.}}</div> -->
                <div>
                    手术名称：<b>{{ checkstatus.surgeries || '--' }}</b>
                </div>
                <div>
                    手术间：<b>{{ checkstatus.dic_operating_room || '--' }}</b>
                </div>
                <div>
                    {{ T(`surgeryinfo.plan_anes_doctor`) }}：<b>{{ checkstatus.anes_doctor || '--' }}</b>
                </div>
                <div>
                    麻醉方法：<b>{{ checkstatus.anaes_methods || '--' }}</b>
                </div>
                <div>
                    手术部位：<b>{{ checkstatus.surgical_site || '--' }}</b>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="checkstatus.dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="dicTags.title" ref="refDicTag" :visible.sync="dicTags.dialogFormVisible" width="25%">
            <div style="height:150px;">
            <el-row>
                <el-col class="padding-left20">
                    <el-select v-model="dicTags.dicTagsValue" filterable remote reserve-keyword placeholder="请输入腕带编号/名称"
                        :remote-method="remoteMethod" @focus="remoteMethod(' ')" class="remoteselect width-p100">
                        <el-option v-for="item in dicTags.options" :key="item.value" :label="item.code" :value="item.value" style="text-align: left;">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="padding20">
                    <div class="dialog-footer">
                        <el-button @click="dicTags.dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="cancelSelectTagsSave">取消绑定</el-button>
                        <el-button type="primary" @click="selectTagsSave">绑 定</el-button>
                    </div>
                </el-col>
            </el-row>
            </div>
        </el-dialog>
 <pdf-frame :base64="base64" :visible.sync="pdfvisible" :title="typeTitle" :modal="false"></pdf-frame>
        <!-- <form-dialog :title="dicTags.title" ref="refDicTag" :data="dicTags.data" width="30%" :visible.sync="dicTags.dialogFormVisible"
            :columns="dicTags.columns" @confirm="selectTagsSave"></form-dialog> -->
    </Layout>
</template>
<script>
import Breadcrumb from '@/common/Breadcrumb.vue'
import { mapGetters } from 'vuex'
import { getScreensData, openNewWindow, isMultiScreen } from '@/common/OpenWindowExpand.js'
function switchToTree(root, menus) {
    return _.orderBy(root, `display_order`).map(r => {
        let children = _.filter(menus, { parent_id: r.id })
        let parent = _.filter(menus, { id: r.parent_id })
        if (!_.startsWith(r.url, `/`)) {
            r.url = (parent && parent[0] && parent[0].url) + `/` + r.url
        }
        return {
            index: r.index,
            is_eject: r.is_eject,
            route: { path: `${r.url}` },
            label: r.name,
            icon: r.icon,
            path: r.url,
            permission: `default`,
            children: children.length > 0 ? switchToTree(children, menus) : []
        }
    })
}
export default {
    name: `Surgery`,
    components: {
        Layout: () => import(`@/components/Layout/Index.vue`),
        TagsView: () => import(`@/common/TagsView.vue`),
        Breadcrumb
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        // 读取暂存的查询条件
        let surgeryQuery = sessionStorage.getItem(`surgery_query`)
        let sessionrdate, sessionsearchKey, sessionisown,
            sessionislocalanes, sessionsurgerytype, sessionsurgerystatus,
            sessionchargestatus, sessiondicroomid, sessionoutoperatingroomtype, sessiongroupkey, sessionisdefaultcollapse = null
        if (surgeryQuery) {
            var obj = JSON.parse(surgeryQuery)
            sessionrdate = obj.rdate
            sessionsearchKey = obj.searchKey
            sessionisown = obj.is_own
            sessionislocalanes = obj.is_local_anes
            sessionsurgerytype = obj.surgery_type
            sessionchargestatus = obj.charge_status
            sessiongroupkey = obj.group_key
            sessionisdefaultcollapse = obj.isdefaultcollapse
            sessionsurgerystatus = obj.surgery_status
            sessiondicroomid = obj.dic_room_id
            sessionoutoperatingroomtype = obj.enum_outoperatingroomtype
        }
        return {
            isFirst: true,
            popovervisible: false,
            enable_tagsview: true,
            defaultOpeneds: [],
            searchKey: sessionsearchKey || ``,
            activeSurgeryId: this.$route.query.surgery_id,
            querySurgeryId: this.$route.query.surgery_id,
            isOnlyShowMain: !!this.$route.query.isOnlyShowMain,
            isOnlyShowRouteNamePage: !!(this.$root.isOnlyShowRouteNamePage && this.$root.isOnlyShowRouteNamePage == `1`),
            isOnlyShowMe: this.$route.query.isOnlyShowMe,
            routeName: this.$route.name,
            activeNames: [],

            surgeries: [],
            setMultiScreen: [],
            IsOperatingRoomConfiguration: this.$root.IsOperatingRoomConfiguration,
            surgerSubStringRule: this.$root.SurgerSubStringRule,
            surgeryStatusConfig: this.$root.SurgeryStatusConfig,
            rdate: sessionrdate || [
                (this.$route.query.rdate && this.$moment(this.$route.query.rdate).format(`YYYY/MM/DD`)) || this.$moment().format(`YYYY/MM/DD`),
                (this.$route.query.rdate && this.$moment(this.$route.query.rdate).format(`YYYY/MM/DD`)) || this.$moment().format(`YYYY/MM/DD`)
            ],
            is_own: sessionisown || false,
            is_local_anes: sessionislocalanes || 0,
            surgery_type: sessionsurgerytype || 0, // 20
            charge_status: sessionchargestatus || 0,
            group_key: sessiongroupkey || 0,
            isdefaultcollapse: sessionisdefaultcollapse == null ? 1 : sessionisdefaultcollapse,
            surgery_status: sessionsurgerystatus || [], // 20
            dic_room_id: sessiondicroomid || undefined,
            enum_outoperatingroomtype: sessionoutoperatingroomtype || undefined,
            searchKey2: ``,
            isRouterAlive: true,
            checkstatus: {
                dialogFormVisible: false,
                title: `核对成功`
            },
            dicTags: {
                title: `绑定手环/手卡`,
                dialogFormVisible: false,
                dicTagsValue: null,
                data: { dic_tag_item: null },
                options: []
                // ,
                // columns: [{
                //     type: `remoteselect`,
                //     prop: `dic_tag_item`,
                //     label: `选择手环/手卡`,
                //     width: `180`,
                //     isListable: true,
                //     options: (that, { row }) => {
                //         return q => {
                //             return this.loadDicTagItemList(q)
                //         }
                //     }
                // }]
            },
            exactQueryConditions: this.$root.ExactQueryConditions && this.$root.ExactQueryConditions != `` && JSON.parse(this.$root.ExactQueryConditions) || [],
            surgeryOrderMode: this.$root.SurgeryOrderMode,
            ageTipConfig: this.$root.AgeTipConfig,
            ageTipConfigInfo: [],
            transportNodes: [],
            isMultiScreen: this.$root.IsMultiScreen == 1,
            base64: ``,
            pdfvisible: false,
            typeTitle: ``,
            isShowCamera: this.$root.isShowCamera && this.$root.isShowCamera == `1`,
            surgeryLoadConfig: (this.$root.SurgeryLoadConfig || `1`) == `1`
        }
    },
    created() {
        let that = this
        // 先找缓存
        let surgeryQuery = sessionStorage.getItem(`surgery_query`)
        if (!surgeryQuery) {
            // 没有缓存找配置参数 患者查询配置
            let queryConfig = that.getAllQueryConfig
            if (queryConfig) {
                that.is_own = queryConfig.surgeryQueryIsOwn || false
                that.is_local_anes = queryConfig.surgeryQueryIslocalanes || 0
                that.surgery_type = queryConfig.surgeryQuerySurgerytype || 0
                that.charge_status = queryConfig.surgeryQueryChargestatus || 0
                that.surgery_status = queryConfig.surgeryQuerySurgerystatus.trim().split(`,`).map(d => parseInt(d))
                that.dic_room_id = queryConfig.surgeryQueryDicroomid
            }
        }
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            if (!this.dic_room_id && this.$root.IsOperatingRoomConfiguration == `1`) {
                this.loadWorkStationConfig()
            }
        })
        this.setMultiScreen = getScreensData(this.isMultiScreen)
        // 日历排程界面小飞机链接过来的时候，不用加载左侧患者列表，直接定位到具体患者即可
        if (this.isOnlyShowMain) {
            this.loadSurgery().then(data => {
                console.log(`loadSurgery`, data)
                let visitInfo = (data.visit_info && data.visit_info) || {}
                let surgerie = {
                    id: data.id,
                    visit_no: visitInfo.visit_no,
                    outpatient_no: visitInfo.outpatient_no,
                    his_id: visitInfo.his_id,
                    bed_no: visitInfo.bed_no,
                    sex: visitInfo.sex,
                    age: visitInfo.age,
                    patient_name: visitInfo.name,
                    dic_section: data.dic_section,
                    remark: data.remark,
                    diseases: (data.fact_diseases && data.fact_diseases.map(i => i.label).join(`,`)) || (data.plan_diseases && data.plan_diseases.map(i => i.label).join(`,`)),
                    surgeries: (data.fact_surgeries && data.fact_surgeries.map(i => i.label).join(`,`)) || (data.plan_surgeries && data.plan_surgeries.map(i => i.label).join(`,`))
                }
                this.surgeries.push(surgerie)
            })
            console.log(`surgeries`, this.surgeries)
        }
        console.log(this.userConfigs)
        if (this.ageTipConfig && this.ageTipConfig.trim() != ``) {
            this.ageTipConfigInfo = JSON.parse(this.ageTipConfig)
        }

        document.addEventListener(`click`, this.popoverClick)
        document.addEventListener(`dblclick`, this.trigCollapse)
    },
    mounted() {
        let that = this
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.$nextTick(() => {
            if (!this.isOnlyShowMain) {
                that.loadSurgeries()
                // 确保整个视图都已渲染完毕

                if (window.broadcaster) {
                    window.broadcaster.addEventListener(`com.android.server.scannerservice.broadcast`, function(data) {
                        console.log(`已扫完码`, data)
                        if (data && data.scannerdata) {
                            that.searchKey2 = data.scannerdata.trim()
                            that.loadSurgeries2()
                        }
                    })
                }
            }
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `layout/collapse`, `permissions`, `workbar`, `operation_ward_auth`, `sys_enums`, `active_ward`, `localip/ipAddress`, `userConfigs`]),
        collapse() {
            return this[`layout/collapse`]
        },
        getAllQueryConfig() {
            let that = this
            let queryConfig = _.filter(that.userConfigs, { catetory: `患者查询配置` })
            if (queryConfig && queryConfig.length > 0) {
                let queryIsOwn = _.find(queryConfig, d => d.key == `surgeryQueryIsOwn`)
                let queryIslocalanes = _.find(queryConfig, d => d.key == `surgeryQueryIslocalanes`)
                let querySurgerytype = _.find(queryConfig, d => d.key == `surgeryQuerySurgerytype`)
                let queryChargestatus = _.find(queryConfig, d => d.key == `surgeryQueryChargestatus`)
                let querySurgerystatus = _.find(queryConfig, d => d.key == `surgeryQuerySurgerystatus`)
                let queryDicroomid = _.find(queryConfig, d => d.key == `surgeryQueryDicroomid`)

                return {
                    surgeryQueryIsOwn: queryIsOwn && queryIsOwn.value == `true`,
                    surgeryQueryIsOwnId: queryIsOwn && parseInt(queryIsOwn.id),
                    surgeryQueryIslocalanes: queryIslocalanes && parseInt(queryIslocalanes.value),
                    surgeryQueryIslocalanesId: queryIslocalanes && parseInt(queryIslocalanes.id),
                    surgeryQuerySurgerytype: querySurgerytype && parseInt(querySurgerytype.value),
                    surgeryQuerySurgerytypeId: querySurgerytype && parseInt(querySurgerytype.id),
                    surgeryQueryChargestatus: queryChargestatus && parseInt(queryChargestatus.value),
                    surgeryQueryChargestatusId: queryChargestatus && parseInt(queryChargestatus.id),
                    surgeryQuerySurgerystatus: querySurgerystatus && querySurgerystatus.value,
                    surgeryQuerySurgerystatusId: querySurgerystatus && parseInt(querySurgerystatus.id),
                    surgeryQueryDicroomid: queryDicroomid && parseInt(queryDicroomid.value) || undefined,
                    surgeryQueryDicroomidId: queryDicroomid && parseInt(queryDicroomid.id)
                }
            }
            return null
        },
        getPlaceholder1() {
            return `请扫${this.T(`surgery.visit_no`)}`
        },
        getPlaceholder2() {
            return `${this.T(`surgery.visit_no`)}/${this.T(`his_id`)}/患者姓名/麻醉医生/护士`
        },

        total() {
            let total = 0
            _.map(this._surgeries, (d, index) => {
                total += d.children.length
            })
            return total
        },
        surgeryStatus() {
            // return [{value:undefined,label:'全部状态'}].concat()
            return _.map(this.sys_enums && this.sys_enums.SurgeryStatus, d => {
                return {
                    value: `${d.value}`,
                    label: d.label
                }
            })
        },
        surgeryTypes() {
            var r = _.map(this.sys_enums && this.sys_enums.Enum_SurgeryType, d => {
                return {
                    value: d.value,
                    label: d.label
                }
            })
            return [{ value: 0, label: `全部类型` }].concat(r)
        },
        query_items: {
            get() {
                return [
                    { value: this.is_own, label: this.is_own ? `我的患者` : `全部患者` },
                    _.find(this.surgeryStatus, { value: this.surgery_status }),
                    _.find(this.operationRoom, { value: this.dic_room_id })
                ]
            },
            set() {}
        },
        menu() {
            // let root = _.filter(this.permissions, { no: 'surgery' })
            let workbarid = this.$route.meta.workbar
            let wf = _.find(this.workbar, { id: workbarid })
            if (!(wf && wf.menu_models)) return []
            let allid = wf.menu_models.map(ar => ar.id)
            let root = _.filter(wf.menu_models, function(r) {
                return _.indexOf(allid, r.parent_id) == -1
            })
            let r = switchToTree(root, wf.menu_models)
            return r.length == 0 ? [] : r.length > 1 ? r : r[0].children
        },
        _menu() {
            let _m = []
            if (this.isOnlyShowRouteNamePage && this.isOnlyShowMain) {
                // 只展示点击的菜单，其它患者菜单隐藏
                _m = this.menu
                    .filter(i => i.index == this.routeName)
                    .map(m => {
                        let r = _.cloneDeep(m)
                        r.route = { path: `${m.route.path}`, query: { surgery_id: this.activeSurgeryId } }
                        return r
                    })
            } else if (this.isOnlyShowMe && this.isOnlyShowMain) {
                // 只展示点击的菜单，其它患者菜单隐藏
                _m = this.menu
                    .filter(i => i.index == this.routeName)
                    .map(m => {
                        let r = _.cloneDeep(m)
                        r.route = { path: `${m.route.path}`, query: { surgery_id: this.activeSurgeryId } }
                        return r
                    })
            } else {
                // 患者tab菜单全部展示出来
                _m = this.menu.map(m => {
                    let r = _.cloneDeep(m)
                    r.route = { path: `${m.route.path}`, query: { surgery_id: this.activeSurgeryId } }
                    return r
                })
            }

            return _m
        },
        _surgeries() {
            let that = this
            let sk = (this.searchKey && this.searchKey.toUpperCase()) || ``
            let r = _.filter(this.surgeries, d => {
                let result = true
                if (result && this.is_own) {
                    result = d.is_own_data_auth_filter
                }
                d.showTime = d.fact_inRoom_time || d.plan_time // 有实际时间显示 实际，没有 显示计划
                if (result && sk.length > 0) {
                    result =
                        (d.patient_abbr && d.patient_abbr.toUpperCase().indexOf(sk) > -1) ||
                        (d.patient_name && d.patient_name.toUpperCase().indexOf(sk) > -1) ||
                        (d.visit_no && d.visit_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.outpatient_no && d.outpatient_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.his_id && d.his_id.toUpperCase().indexOf(sk) > -1) ||
                        (d.plan_anes_doctor && (d.plan_anes_doctor.label.toUpperCase().indexOf(sk) > -1 || d.plan_anes_doctor.jianpin.toUpperCase().indexOf(sk) > -1)) ||
                        (d.plan_anes_assistants && d.plan_anes_assistants.length > 0 && d.plan_anes_assistants.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1) ||
                        (d.plan_circuit_nurse && d.plan_circuit_nurse.length > 0 && d.plan_circuit_nurse.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1) ||
                        (d.plan_equipment_nurse && d.plan_equipment_nurse.length > 0 && d.plan_equipment_nurse.findIndex(i => { return i && i.label ? i.label.toUpperCase().indexOf(sk) > -1 : false }) > -1)
                }

                // 包含自定义查询条件，根据自定义条件过滤数据
                if (result && this.exactQueryConditions && this.exactQueryConditions.length > 0 && d.surgeryTipItemsList && d.surgeryTipItemsList.length > 0) {
                    let flag = true
                    _.forEach(d.surgeryTipItemsList, r => {
                        let condition = _.find(that.exactQueryConditions, e => {
                            return e.selectedItem != 0 && e.selectedItem != `全部` && e.type == r.title
                        })
                        if (condition) {
                            flag = r.label == condition.selectedItem
                            if (!flag) {
                                return flag
                            }
                        }
                    })
                    result = flag
                }

                return result
            })
            if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                if (this.surgeryOrderMode == `0`) {
                    r = _.orderBy(r, [`dic_operating_room_order`, `in_room_time`, `sequence`], [`asc`, `asc`, `asc`])
                } else if (this.surgeryOrderMode == `2`) {
                    r = _.orderBy(r, [`dic_operating_room_order`, `plan_date`, `sequence`], [`asc`, `asc`, `asc`])
                } else if (this.surgeryOrderMode == `3`) {
                    r = _.orderBy(r, [`dic_operating_room_order`, `showTime`], [`asc`, `asc`])
                } else if (this.surgeryOrderMode == `4`) {
                    r = _.orderBy(r, [`dic_operating_room_order`, `status_order`, `scheduled_num`], [`asc`, `asc`, `asc`])
                } else {
                    r = _.orderBy(r, [`dic_operating_room_order`, `plan_date`, `scheduled_num`], [`asc`, `asc`, `asc`])
                }
            }
            if (this.active_ward && _.startsWith(this.active_ward.value, `rw_`)) {
                if (this.surgeryOrderMode == `0`) {
                    r = _.orderBy(r, [`dic_recovery_ward_order`, `in_recovery_room`], [`asc`, `asc`])
                } else if (this.surgeryOrderMode == `2`) {
                    r = _.orderBy(r, [`dic_recovery_ward_order`, `plan_date`, `sequence`], [`asc`, `asc`, `asc`])
                } else if (this.surgeryOrderMode == `3`) {
                    r = _.orderBy(r, [`dic_recovery_ward_order`, `showTime`], [`asc`, `asc`])
                } else if (this.surgeryOrderMode == `4`) {
                    r = _.orderBy(r, [`dic_operating_room_order`, `status_order`, `scheduled_num`], [`asc`, `asc`, `asc`])
                } else {
                    r = _.orderBy(r, [`dic_recovery_ward_order`, `plan_date`, `scheduled_num`], [`asc`, `asc`, `asc`])
                }
            }
            if (sk.length === 0) {
            // ACIS-24195,应该拿过滤后并排好序的值
                if (this.querySurgeryId == undefined) {
                    if (this.activeSurgeryId == undefined && r[0]) {
                        this.cus_collapse_item_active(r[0].id)
                    } else if (this.activeSurgeryId && r[0] && _.findIndex(r, { id: this.activeSurgeryId * 1 }) == -1) {
                        this.cus_collapse_item_active(r[0].id)
                    }
                }
            }
            console.log(`group_key`, this.group_key)
            console.log(`r1`, r)
            if (this.group_key == 0) {
                r = _.reduce(
                    _.groupBy(r, `dic_operating_room_id`),
                    function(result, g, key) {
                        result.push({
                            room_id: `room_${key}`,
                            room: g[0].dic_operating_room,
                            order: g[0].dic_operating_room_order,
                            children: g
                        })
                        return result
                    },
                    []
                )
            } else {
                r = _.reduce(
                    _.groupBy(r, `dic_inpatient_section_id`),
                    function(result, g, key) {
                        result.push({
                            room_id: `room_${key}`,
                            room: g[0].dic_inpatient_section,
                            order: g[0].dic_inpatient_section_order,
                            children: g
                        })
                        return result
                    },
                    []
                )
            }

            r = r.sort((a, b) => a.order - b.order)

            console.log(`rrrrrrrrrrrr`, r)
            return r
        },
        activeSurgery() {
            let that = this
            that.loadTransportNodes()
            let r = _.find(that.surgeries, { id: that.activeSurgeryId * 1 }) || {}
            if (r) {
                if (r.age) {
                    if (!_.includes(r.age, `岁`) && !_.includes(r.age, `月`) && !_.includes(r.age, `周`) && !_.includes(r.age, `天`)) {
                        r.age = r.age + `岁`
                    }
                }
                if (r.age_int || r.age_int == 0) {
                    console.log(r)
                    if (that.ageTipConfig && that.ageTipConfig.trim() != ``) {
                        that.ageTipConfigInfo = JSON.parse(that.ageTipConfig)
                        let config = JSON.parse(that.ageTipConfig)
                        if (config && config.length > 0) {
                            var TipInfo = config.filter(d => {
                                return d.Min <= r.age_int && d.Max >= r.age_int
                            })
                            if (TipInfo && TipInfo.length > 0) {
                                r.ageColor = TipInfo[0].FontColor
                            }
                        }
                    }
                }
            }
            return r
        },
        operationRoom() {
            return [{ value: undefined, label: `全部手术间` }].concat(
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                    []
            )
        },
        allOutOperatingRoomTpyes() {
            return [{ value: undefined, label: `全部` }].concat(
                this.sys_enums.Enum_OutOperatingRoomType ||
                []
            )
        },
        displayOperationRoomFilter() {
            return this.active_ward && this.active_ward.operation_room
        }
    },
    methods: {
        collapseSurgeries() {
            if (this.isdefaultcollapse) {
                this.defaultOpeneds = _.map(this._surgeries, `room_id`)
            } else {
                this.defaultOpeneds = []
            }
        },
        loadDocument(recordType, id) {
            console.log(`12312312`, this.setMultiScreen)
            // 多屏直接在其他屏幕打开
            if (isMultiScreen(this.setMultiScreen)) {
                var that = this
                let req = this.myaxios.get(`/api/Operation/Home/GetPdfUrl?surgeryInfoId=${id}&recordType=${recordType}`)
                req.then(data => {
                    if (data) {
                        that.basepdf = data
                        let r = typeof winformMsg
                        if (r != `undefined`) {
                            var cefJson = {
                                action: `openPdfView`,
                                pdfUrl: this.basepdf
                            }
                            winformMsg.acceptMessage(cefJson)
                        } else { openNewWindow(this.basepdf, `文档`, this.setMultiScreen) }
                    } else { this.$message.error(`未能获取文档地址`) }
                }).catch(e => console.log(e))
            } else {
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${id}&recordType=${recordType}`)
                req.then(data => {
                    let title = `麻醉记录单`
                    if (recordType == 2) {
                        title = `复苏记录单`
                    } else if (recordType == 0) {
                        title = `合并记录单`
                    }
                    this.pdfvisible = true
                    this.base64 = data
                    this.typeTitle = title
                }).catch(e => console.log(e))
            }
        },
        remoteMethod(query) {
            if (query !== ``) {
                this.loadDicTagItemList(query).then(data => {
                    this.dicTags.options = data
                })
            } else {
                this.dicTags.options = []
            }
        },
        loadTransportNodes() {
            if (this.activeSurgeryId > 0) {
                let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetProcSurgeryTransport/${this.activeSurgeryId}`)
                req.then(data => {
                    this.transportNodes =
                    data &&
                    _.map(data, d => {
                        d.title = d.event_name
                        d.status = d.id > 0 ? `primary` : `info`
                        return d
                    })
                    console.log(this.transportNodes)
                }).catch(e => {
                    console.log(e)
                })
            } else {
                this.transportNodes = []
            }
        },
        // 重置方法
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        popoverClick(e) {
            let that = this
            let btntarget = document.getElementById(`popoverBtn`)
            if (btntarget && btntarget.contains(e.target)) {
                that.popovervisible = !that.popovervisible
            } else {
                let result = false
                let popovers = document.getElementsByClassName(`.el-popover`)
                _.forEach(popovers, item => {
                    if ((item && item.contains(e.target))) {
                        result = true
                    }
                })
                if (result) {
                    console.log(`el-popover`)
                    that.popovervisible = true
                } else {
                    let apptarget = document.getElementById(`app`)
                    if (that.isFirst || (apptarget && apptarget.contains(e.target))) {
                        that.popovervisible = false
                    }
                    if (that.popovervisible == true) {
                        let currentTheme = localStorage.getItem(`app_theme`) || `theme-dark`
                        let themetarget = document.getElementsByClassName(currentTheme)
                        _.forEach(themetarget, target => {
                            if ((target && target.contains(e.target))) {
                                result = false
                            }
                        })
                        let fullscreentarget = document.getElementsByClassName(`el-loading-mask is-fullscreen`)
                        _.forEach(fullscreentarget, target => {
                            if ((target && target.contains(e.target))) {
                                result = true
                            }
                        })
                        let parenttarget = document.getElementsByClassName(`${currentTheme} el-loading-parent--relative el-loading-parent--hidden`)
                        _.forEach(parenttarget, target => {
                            if ((target && target.contains(e.target))) {
                                result = true
                            }
                        })
                        if (!result) {
                            that.popovervisible = false
                            console.log(e.target)
                        } else {
                            that.popovervisible = true
                        }
                    }
                }
            }
        },
        trigCollapse(e) {
            let that = this
            let result = false
            let btntarget = document.getElementsByClassName(`surgery-content`)

            _.forEach(btntarget, target => {
                if ((target && target.contains(e.target))) {
                    result = true
                }
            })

            let btntargettip = document.getElementsByClassName(`surgery-content el-tooltip`)
            _.forEach(btntargettip, target => {
                if ((target && target.contains(e.target))) {
                    result = true
                }
            })

            let btntargettip2 = document.getElementsByClassName(`surgery-content el-tooltip b`)
            _.forEach(btntargettip2, target => {
                if ((target && target.contains(e.target))) {
                    result = true
                }
            })

            let btntargettip3 = document.getElementsByClassName(`surgery-content el-tooltip span`)
            _.forEach(btntargettip3, target => {
                if ((target && target.contains(e.target))) {
                    result = true
                }
            })

            let btntargettip4 = document.getElementsByClassName(`surgery-content el-tooltip div`)
            _.forEach(btntargettip4, target => {
                if ((target && target.contains(e.target))) {
                    result = true
                }
            })

            let fullscreentarget = document.getElementsByClassName(`el-loading-mask is-fullscreen`)
            _.forEach(fullscreentarget, target => {
                if ((target && target.contains(e.target) && e.x > 62 && e.x < 263)) {
                    result = true
                }
            })
            if (result) {
                that.$nextTick(() => {
                    that.$refs.layout && that.$refs.layout.triggerCollapse()
                })
            }
        },
        onPopoverHide() {
            let that = this
            let oldConfig = this.getAllQueryConfig
            let changeList = []
            if (!oldConfig || oldConfig.surgeryQueryIsOwn != that.is_own) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQueryIsOwnId, key: `surgeryQueryIsOwn`, value: that.is_own, description: `医护默认查询`, catetory: `患者查询配置` })
            }
            if (!oldConfig || oldConfig.surgeryQueryIslocalanes != that.is_local_anes) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQueryIslocalanesId, key: `surgeryQueryIslocalanes`, value: that.is_local_anes, description: `麻醉类型默认查询`, catetory: `患者查询配置` })
            }
            if (!oldConfig || oldConfig.surgeryQuerySurgerytype != that.surgery_type) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQuerySurgerytypeId, key: `surgeryQuerySurgerytype`, value: that.surgery_type, description: `手术类型默认查询`, catetory: `患者查询配置` })
            }
            if (!oldConfig || oldConfig.surgeryQueryChargestatus != that.charge_status) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQueryChargestatusId, key: `surgeryQueryChargestatus`, value: that.charge_status, description: `计费默认查询`, catetory: `患者查询配置` })
            }
            let newStatus = [...new Set(that.surgery_status)]
            if (!oldConfig || oldConfig.surgeryQuerySurgerystatus != newStatus) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQuerySurgerystatusId, key: `surgeryQuerySurgerystatus`, value: newStatus.join(`,`), description: `手术状态默认查询`, catetory: `患者查询配置` })
            }
            if (!oldConfig || oldConfig.surgeryQueryDicroomid != that.dic_room_id) {
                changeList.push({ id: oldConfig && oldConfig.surgeryQueryDicroomidId, key: `surgeryQueryDicroomid`, value: that.dic_room_id || ``, description: `手术间默认查询`, catetory: `患者查询配置` })
            }
            if (changeList.length > 0) {
                let req = that.myaxios.post(`/api/AcisSystem/UserConfig/ChangeUserConfig`, changeList)
                req.then(data => {
                    that.$store.dispatch(`ADD_USERCONFIG`)
                }).catch(e => {
                    that.$store.dispatch(`ADD_USERCONFIG`)
                    console.log(`配置失败`)
                    console.log(changeList)
                })
            }
        },
        getFirstLetter(str) {
            return _.first(str) + `*` + _.last(str)
        },
        // 2022-03-30 10:30, ACIS-23429 患者界面默认带出手术室的患者 而不是所有手术室的患者
        loadWorkStationConfig() {
            // 2022-04-1 10:30, dongping.wang,ACIS-23429:判断是否启用配置手术间 0 为不启用 1 为启用
            if (!this[`localip/ipAddress`]) return
            return new Promise(resolve => {
                // 2022-04-1 10:30, dongping.wang,ACIS-23429:请求：获取当前站点配置的默认手术间 参数：站点Ip
                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                this.myaxios.all(req).then(([data]) => {
                    this.dic_room_id = (data && data.dic_operating_room_id) || null
                })
            }).catch(e => {
                console.log(e)
            })
        },
        // 绑定腕带，用来做患者转运
        onRightClick(surgeryId) {
            let that = this
            this.activeSurgeryId = surgeryId
            this.cus_collapse_item_active(surgeryId)
            this.loadSurgery().then(data => {
                let visitInfo = (data.visit_info && data.visit_info) || {}
                that.loadSurgeryTag().then(res => {
                    that.dicTags.title = !res ? `患者:${visitInfo.name} 未绑定腕带` : `患者:${visitInfo.name} 已绑定腕带:${res.dic_tag_name},编号:${res.dic_tag_code}`
                    that.dicTags.dialogFormVisible = true
                })
            })
        },
        loadSurgeryTag() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/RelTagSurgeryInfo/GetDicTagBySurgeryId?surgeryId=${this.activeSurgeryId}`)
                req.then(data => {
                    resolve(data)
                })
            }).catch(e => {
                console.log(e)
            })
        },
        cancelSelectTagsSave() {
            this.bindTag(this.dicTags.dicTagsValue, this.activeSurgeryId, false)
            this.dicTags.dialogFormVisible = false
            this.dicTags.dicTagsValue = null
        },
        selectTagsSave() {
            if (this.dicTags.dicTagsValue) {
                this.bindTag(this.dicTags.dicTagsValue, this.activeSurgeryId, true)
                this.dicTags.dialogFormVisible = false
                this.dicTags.dicTagsValue = null
            } else {
                this.$message.error(`请选择手环`)
            }
        },
        bindTag(dictagid, bizsurgeryinfoid, isbind) {
            let reftagsuregey = {
                dic_tag_id: dictagid,
                biz_surgery_info_id: bizsurgeryinfoid,
                isbind: isbind // 绑定
            }
            let req = this.myaxios.post(`/api/AcisSystem/RelTagSurgeryInfo/Post`, reftagsuregey)
            req.then(data => {
                this.$message.success(`患者手环${isbind ? `绑定` : `解绑`}成功`)
            }).catch(e => {
                this.$message.error(e)
            })
        },
        loadDicTagItemList(keyword) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/DicTag/GetAllUnBind?keyword=${keyword}`)
                req.then(data => {
                    data = _.map(data, d => {
                        let codes = []
                        codes.push(d.code)
                        codes.push(d.name)
                        return {
                            ...d,
                            value: d.id,
                            label: d.code,
                            code: codes.join(`/`)
                        }
                    })
                    resolve(data)
                })
            })
        },
        cus_collapse_item_active(surgeryId) {
            let that = this
            let { name, query } = that.$route
            if (surgeryId > 0 && query && query.surgery_id !== surgeryId) {
                let t = _.find(that.menu, [`index`, name]) || that.menu[0]
                let r = { path: t.path, query: { surgery_id: surgeryId } }
                if (query.charge_type) {
                    r.query.charge_type = query.charge_type
                }
                if (query.source) {
                    r.query.source = query.source
                }
                // 数据变化后，切换则提醒，如果在路由里面选择不离开当前页面，则不切换菜单
                that.$router.push(r).then(d => {
                    console.log(d.message)
                    if (d && d.message == `不跳转路由`) {

                    } else {
                        that.$store.commit(`setCurrentSurgery`, _.find(that.surgeries, { id: surgeryId }))
                        that.activeSurgeryId = surgeryId
                        // 切换的时候不重新加载，不然很卡！
                        // that.loadSurgeries(false)
                    }
                })
            } else if (!surgeryId) {
                let t = _.find(that.menu, [`index`, name]) || that.menu[0]
                that.$router.push({ path: t.path }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadSurgery() {
            if (this.activeSurgeryId) {
                return this.myaxios.get(`/api/Preoperative/Apply/Get/${this.activeSurgeryId}`)
            } else {
                return Promise.resolve({})
            }
        },
        loadSurgeries(showloading = true) {
            let conditions = this.getAllConditions()
            return new Promise(resolve => {
                let req = this.myaxios.post(
                    `/api/Operation/Home/GetPatientListByDateRange`,
                    conditions, null, showloading
                )

                let req1 = this.myaxios.post(`api/Nursing/Charge/GetSurgeryTipItems`, conditions, null, false)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.surgeries = data.map(i => {
                        let r = _.cloneDeep(i)
                        r.status_order = 10
                        if (r.enum_surgery_status == 10) {
                            r.status_order = 1
                        } else if (r.enum_surgery_status == 30) {
                            r.status_order = 2
                        } else if (r.enum_surgery_status == 20) {
                            r.status_order = 3
                        } else if (r.enum_surgery_status > 30) {
                            r.status_order = 4
                        }
                        if (data1 && data1.length) {
                            let surgeryTip = data1.filter(i => i.biz_surgeryinfo_id == r.id)
                            let tipItem = surgeryTip || []
                            r.surgeryTipItemsList = tipItem
                        } else {
                            r.surgeryTipItemsList = []
                        }
                        r.plan_date = this.$moment(i.plan_time).format(`YYYY/MM/DD`)
                        if (r.age && r.age.length > 3) {
                            r.ageVal = r.age.substring(0, 3) + `..`
                        } else {
                            r.ageVal = r.age
                        }
                        return r
                    })

                    // 手术列表为空时，清除surgery_id
                    if (this.surgeries.length == 0) {
                        this.$router.push({ path: this.$route.path })
                    }
                    this.collapseSurgeries()
                    resolve()
                }).catch(e => {
                    this.surgeries = []
                    this.$router.push({ path: this.$route.path })
                    resolve()
                })
            })
        },
        getAllConditions() {
            let operatingWardId = 0
            let operatingRoomId = 0
            let recoveryWardId = 0

            if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                operatingWardId = this.active_ward.origion || 0
                operatingRoomId = this.dic_room_id || 0
                recoveryWardId = 0
            }
            // 选复苏室则只看在当前复苏室的患者
            if (this.active_ward && _.startsWith(this.active_ward.value, `rw_`)) {
                operatingWardId = 0
                operatingRoomId = 0
                recoveryWardId = this.active_ward.origion || 0
            }
            var queryCondition = {
                begin: this.rdate[0],
                end: this.$moment(this.rdate[1])
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`),
                is_local_anes: this.is_local_anes,
                surgery_type: this.surgery_type,
                charge_status: this.charge_status,
                surgery_status: this.surgery_status,
                dic_operating_room_id: operatingRoomId,
                dic_recovery_ward_id: recoveryWardId,
                dic_operating_ward_id: operatingWardId,
                enum_outoperatingroomtype: this.enum_outoperatingroomtype
            }

            return queryCondition
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        loadSurgeries2() {
            if (!this.$root.WristBandScanCheckProc.startsWith(`proc`)) {
                this.searchKey2 = this.substringcdata(this.searchKey2)
            }
            console.log(this.searchKey2)
            let sk = (this.searchKey2 && this.searchKey2.toUpperCase()) || ``
            if (sk.length > 0) {
                if (this.$root.WristBandScanCheckProc.startsWith(`proc`)) {
                    var queryCondition = {
                        begin: this.rdate[0],
                        end: this.$moment(this.rdate[1])
                            .add(1, `days`)
                            .format(`YYYY/MM/DD`),
                        visit_no: this.searchKey2
                    }
                    let req = this.myaxios.post(`/api/Operation/Home/GetSurgeryInRoomCheck`, queryCondition)
                    req.then(data => {
                        console.log(data)
                        if (!data.result) {
                            this.$alert(`<strong>` + data.msg + `</strong>`, `核对失败`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            this.searchKey2 = ``
                            return
                        }

                        let patient = _.find(
                            this.surgeries.sort((a, b) => b.visit_id - a.visit_id),
                            d => {
                                return d.id == data.msg
                            })
                        if (patient) {
                            if (this.surgeryLoadConfig && this.dic_room_id && patient.dic_operating_room_id !== this.dic_room_id) {
                                this.$alert(`<strong>非本手术间今日排程手术患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else if (this.surgeryLoadConfig && `ow_${patient.dic_operating_ward_id}` !== (this.active_ward && this.active_ward.value)) {
                                this.$alert(`<strong>非本手术区今日排程手术患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else {
                                Object.assign(this.checkstatus, patient)
                                this.checkstatus.dialogFormVisible = true
                                this.cus_collapse_item_active(patient.id)
                            }
                        } else {
                            this.$message.warning(`暂无该患者信息`)
                        }
                    }).catch(e => {
                        this.$message.error(e)
                    })
                } else {
                    // ACIS-19803 验证手术
                    let patient = _.find(
                        this.surgeries.sort((a, b) => b.visit_id - a.visit_id),
                        d => {
                            let visitId = d.his_id && `${d.his_id.toUpperCase()}_${d.visit_count}`
                            return visitId == sk || d.visit_no == sk || d.his_id == sk
                        }
                    )
                    if (patient) {
                        if (this.surgeryLoadConfig && !(patient.plan_time && this.$moment(patient.plan_time).format(`YYYYMMDD`) == this.$moment().format(`YYYYMMDD`))) {
                            this.$alert(`<strong>非今日排程手术患者！</strong>`, `核对失败`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        } else {
                            if (this.surgeryLoadConfig && this.dic_room_id && patient.dic_operating_room_id !== this.dic_room_id) {
                                this.$alert(`<strong>非本手术间今日排程手术患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else if (this.surgeryLoadConfig && `ow_${patient.dic_operating_ward_id}` !== (this.active_ward && this.active_ward.value)) {
                                this.$alert(`<strong>非本手术区今日排程手术患者！</strong>`, `核对失败`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                })
                            } else {
                                Object.assign(this.checkstatus, patient)
                                this.checkstatus.dialogFormVisible = true
                                // this.$alert(`
                                // <div style='font-size:18px'>
                                //   <div>
                                //     <span>姓名：${patient.patient_name}</span>&nbsp;&nbsp;
                                //     <span>床号：${patient.bedno||'--'}</span>&nbsp;&nbsp;
                                //     <span>性别：${patient.sex||'--'}</span>&nbsp;&nbsp;
                                //     <span>年龄：${patient.age||'--'}</span>
                                //   </div>
                                //   <div>
                                //     <span>台次：${patient.sequence}</span>&nbsp;&nbsp;
                                //     <span>住院号：${patient.visit_no}</span>&nbsp;&nbsp;
                                //     <span>门诊号：${patient.his_id}</span>&nbsp;&nbsp;
                                //   </div>
                                //   <div>
                                //     <span>巡回护士：${patient.circuit_nurse}</span>&nbsp;&nbsp;
                                //     <span>器械护士：${patient.equipment_nurse}</span>&nbsp;&nbsp;
                                //   </div>
                                //   <div>科室：${patient.dic_section||'--'}</div>
                                //   <div>手术医生：${patient.surgeon||'--'}，${patient.surgeon_assistants||'--'}</div>
                                //   <div>手术部位：${''}</div>
                                //   <div>手术名称：${patient.surgeries||'--'}</div>
                                //   <div>手术间：${patient.dic_operating_room||'--'}</>
                                //   <div>麻醉医生：${patient.anes_doctor||'--'}</div>
                                //   <div>麻醉方法：${patient.anaes_methods||'--'}</div>
                                // </div>
                                //             `, '核对成功', {
                                //   dangerouslyUseHTMLString: true
                                // })

                                this.cus_collapse_item_active(patient.id)
                            }
                        }
                    } else {
                        this.$message.warning(`暂无该患者信息`)
                    }
                }
                this.searchKey2 = ``
            }
        },
        changeSurgeInfo(surgeInfo) {
            this.loadTransportNodes()
            // ACIS-22861 added by xiaorui，当局部麻醉手术状态改变后触发执行
            let surgs = this._surgeries
            if (surgs && surgs.length > 0) {
                _.forEach(surgs, s => {
                    let changeSurgInfo = _.find(s.children, c => {
                        return c.id == surgeInfo.id
                    })
                    if (changeSurgInfo) {
                        if (surgeInfo.surgery_status) {
                            this.$set(changeSurgInfo, `surgery_status`, surgeInfo.surgery_status)
                        }
                        if (surgeInfo.enum_surgery_status) {
                            this.$set(changeSurgInfo, `enum_surgery_status`, surgeInfo.enum_surgery_status)
                        }
                        if (surgeInfo.save && surgeInfo.save == true) {
                            this.loadSurgeries()
                        }
                    }
                })
            }
        },
        refreshsurgeInfos() {
            this.loadSurgeries()
        },
        getSurgeryStatusConfig() {
            let outval = []
            if (this.surgeryStatusConfig && this.surgeryStatusConfig != ``) {
                outval = this.surgeryStatusConfig.split(`|`)
            }
            return outval
        }
    },
    beforeDestroy() {
        // 暂存查询条件
        var queryCondition = {
            rdate: this.rdate,
            searchKey: this.searchKey,
            is_own: this.is_own,
            is_local_anes: this.is_local_anes,
            surgery_type: this.surgery_type,
            charge_status: this.charge_status,
            surgery_status: [...new Set(this.surgery_status)],
            dic_room_id: this.dic_room_id,
            group_key: this.group_key,
            isdefaultcollapse: this.isdefaultcollapse,
            enum_outoperatingroomtype: this.enum_outoperatingroomtype
        }

        sessionStorage.setItem(`surgery_query`, JSON.stringify(queryCondition))
        document.removeEventListener(`click`, this.popoverClick)
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (!this.isOnlyShowMain) {
                this.activeSurgeryId = newUrl.query.surgery_id
            }
        },
        active_ward: {
            immediate: true, // 首次加载的时候执行函数
            handler: function(newVal, oldVal) {
                if (newVal && oldVal && newVal.value != oldVal.value) {
                    console.log(`222222222222222`, newVal)
                    console.log(`222222222222222`, oldVal)
                    // 日历排程界面小飞机链接过来的时候，不用加载左侧患者列表，直接定位到具体患者即可
                    if (!this.isOnlyShowMain) {
                        let surgeryStatusArr = this.getSurgeryStatusConfig()
                        if (this.active_ward && _.startsWith(this.active_ward.value, `rw_`)) {
                            if (!this.surgery_status || this.surgery_status.length == 0) {
                                this.surgery_status = [`50`, `60`]
                            }
                        } else {
                            if (surgeryStatusArr.length == 0) {
                                this.surgery_status = _.difference([`20`, `30`, `40`, `50`, `60`, `-2`], this.surgery_status).concat([`20`, `30`, `40`, `50`, `60`, `-2`])
                            } else {
                                if (!this.surgery_status || this.surgery_status.length == 0) {
                                    this.surgery_status = surgeryStatusArr
                                }
                            // this.surgery_status = _.difference(surgeryStatusArr, this.surgery_status).concat(surgeryStatusArr)
                            }
                        }
                        if (this.surgery_status.length > 0) {
                            this.loadSurgeries()
                        }
                    }
                }
            }
        },
        dic_room_id: function(newVlaue, oldValue) {
            if (!this.isOnlyShowMain && this.surgery_status.length > 0) {
                this.loadSurgeries(true)
            }
        },
        group_key: function(newVlaue, oldValue) {
            if (!this.isOnlyShowMain && this.surgery_status.length > 0) {
                this.loadSurgeries(true)
            }
        },
        rdate: function(newVlaue, oldValue) {
            // 日历排程界面小飞机链接过来的时候，不用加载左侧患者列表，直接定位到具体患者即可
            if (!this.isOnlyShowMain && this.surgery_status.length > 0) {
                this.loadSurgeries()
            }
        },
        enum_outoperatingroomtype: function(newVlaue, oldValue) {
            if (!this.isOnlyShowMain && this.surgery_status.length > 0) {
                this.loadSurgeries(true)
            }
        }
    }
}
</script>
<style scoped lang="less">
.sub-menu {
    height: 35px;
    /*background: #fff;*/
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    color: #a1aaac;
    .p_name {
        color: #3c4758;
    }
    .el-col {
        &:first-of-type {
            line-height: 35px;
        }
    }
}
.el-icon-search {
    color: red;
    cursor: pointer;
    &:hover {
        color: whitesmoke;
    }
}

.bg-danger {
    color: #ff7e7e !important;
}
</style>
<style lang="less">
.surgery-index-popover {
    .el-radio,
    .el-checkbox {
        width: 130px;
        margin: 0 10px 5px 0;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Index.vue